var render = function render(){
  var _vm$dataForm, _vm$dataForm2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between mb-3"
  }, [_c('div', [_vm.dataForm.some(function (el) {
    return el.checked;
  }) ? _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.bulkDeleteForm
    }
  }, [_vm._v(" Bulk Delete ")]) : _vm._e()], 1), !_vm.selectedData ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Form ")]) : _vm._e()], 1), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('table', {
    staticClass: "w-100 table-striped"
  }, [_c('thead', [!_vm.selectedData ? _c('th', [_c('input', {
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.dataForm.every(function (el) {
        return el.checked;
      }) && ((_vm$dataForm = _vm.dataForm) === null || _vm$dataForm === void 0 ? void 0 : _vm$dataForm.length)
    },
    on: {
      "change": _vm.handleCheckAll
    }
  })]) : _vm._e(), _c('th', [_vm._v("FLEET NAME")]), _c('th', [_vm._v("DATE INPUT")]), _c('th', [_vm._v("ENGINE NAME")]), _c('th', [_vm._v("HOURS")])]), _vm.dataForm.length ? _c('tbody', [_vm._l(_vm.dataForm, function (item, i) {
    return _vm._l(item === null || item === void 0 ? void 0 : item.runningHours, function (subItem, j) {
      var _item$runningHours, _item$runningHours2, _item$runningHours3;
      return _c('tr', {
        key: "".concat(i, "-").concat(j)
      }, [j === 0 && !_vm.selectedData ? _c('td', {
        staticClass: "bg-white",
        staticStyle: {
          "border-bottom": "1px solid #dee2e6"
        },
        attrs: {
          "rowspan": (_item$runningHours = item.runningHours) === null || _item$runningHours === void 0 ? void 0 : _item$runningHours.length
        }
      }, [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: item.checked,
          expression: "item.checked"
        }],
        staticClass: "mr-3 mb-0 cursor-pointer bg-white",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : item.checked
        },
        on: {
          "change": function change($event) {
            var $$a = item.checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && _vm.$set(item, "checked", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(item, "checked", $$c);
            }
          }
        }
      }), _c('i', {
        staticClass: "fa fa-trash text-danger cursor-pointer",
        on: {
          "click": function click() {
            return _vm.deleteForm(i);
          }
        }
      })])]) : _vm._e(), j === 0 ? _c('td', {
        staticClass: "bg-white",
        staticStyle: {
          "width": "280px",
          "border-bottom": "1px solid #dee2e6"
        },
        attrs: {
          "rowspan": (_item$runningHours2 = item.runningHours) === null || _item$runningHours2 === void 0 ? void 0 : _item$runningHours2.length
        }
      }, [_c('v-select', {
        attrs: {
          "options": _vm.fleetOptions,
          "label": "name",
          "reduce": function reduce(option) {
            return option === null || option === void 0 ? void 0 : option.id;
          }
        },
        on: {
          "input": function input(val) {
            return _vm.handleSelect(val, i);
          }
        },
        model: {
          value: item.vehicle_id,
          callback: function callback($$v) {
            _vm.$set(item, "vehicle_id", $$v);
          },
          expression: "item.vehicle_id"
        }
      })], 1) : _vm._e(), j === 0 ? _c('td', {
        staticClass: "bg-white",
        staticStyle: {
          "width": "280px",
          "border-bottom": "1px solid #dee2e6"
        },
        attrs: {
          "rowspan": (_item$runningHours3 = item.runningHours) === null || _item$runningHours3 === void 0 ? void 0 : _item$runningHours3.length
        }
      }, [_c('date-picker', {
        staticClass: "text-black",
        attrs: {
          "value-type": "DD-MM-YYYY",
          "type": "date",
          "placeholder": "Select date",
          "format": "DD-MM-YYYY",
          "disabled": _vm.selectedData,
          "input-attr": {
            required: true
          }
        },
        model: {
          value: item.date,
          callback: function callback($$v) {
            _vm.$set(item, "date", $$v);
          },
          expression: "item.date"
        }
      })], 1) : _vm._e(), _c('td', {
        staticStyle: {
          "width": "400px"
        }
      }, [_c('strong', [_vm._v(_vm._s(subItem === null || subItem === void 0 ? void 0 : subItem.engineName))]), _c('br'), _c('small', [_vm._v(_vm._s(subItem === null || subItem === void 0 ? void 0 : subItem.engineSeries))])]), _c('td', [_c('div', {
        staticClass: "d-flex align-items-center",
        staticStyle: {
          "max-width": "240px"
        }
      }, [_c('div', {
        staticClass: "d-flex align-items-center",
        staticStyle: {
          "width": "110px"
        }
      }, [item.vehicle_id ? _c('b-form-input', {
        staticClass: "bg-white rounded-sm text-right text-black",
        staticStyle: {
          "width": "100px"
        },
        attrs: {
          "type": "number",
          "placeholder": "0",
          "min": 0,
          "max": 24
        },
        on: {
          "blur": function blur($event) {
            return _vm.handleBlurInput($event, subItem, 'hours');
          }
        },
        model: {
          value: subItem.hours,
          callback: function callback($$v) {
            _vm.$set(subItem, "hours", $$v);
          },
          expression: "subItem.hours"
        }
      }) : _vm._e()], 1)])])]);
    });
  })], 2) : _c('tbody', [_vm._m(0)])]), _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('b-button', {
    staticClass: "w-50 mr-3",
    attrs: {
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel ")]), !_vm.loading ? _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "disabled": !((_vm$dataForm2 = _vm.dataForm) !== null && _vm$dataForm2 !== void 0 && _vm$dataForm2.length),
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v(" Submit ")]) : _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Saving... ")], 1)], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Data Form")])]);

}]

export { render, staticRenderFns }